import React from 'react';
import { Link } from 'react-router-dom';
import { Github, Twitter, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-100 dark:bg-gray-950 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4 text-gray-900 dark:text-white">
              CognitAIX
            </h3>
            <p className="text-gray-600 dark:text-gray-400">
              Innovating Excel with AI & Web.
            </p>
          </div>

          {/* Explore Links */}
          <div className="col-span-1">
            <h4 className="text-sm font-semibold mb-4 text-gray-900 dark:text-white">
              Explore
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 dark:text-gray-400 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="text-gray-600 dark:text-gray-400 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300">
                  Solutions
                </Link>
              </li>
              <li>
                <Link to="/webaiexcel" className="text-gray-600 dark:text-gray-400 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300">
                  WebAIExcel
                </Link>
              </li>
              <li>
                <Link to="/blogs" className="text-gray-600 dark:text-gray-400 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300">
                  Blogs
                </Link>
              </li>
              {/*
              <li>
                <Link to="/playground" className="text-gray-600 dark:text-gray-400 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300">
                  Playground
                </Link>
              </li>              
              <li>
                <Link to="/portal" className="text-gray-600 dark:text-gray-400 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300">
                  Portal
                </Link>
              </li>
              */}
            </ul>
          </div>

          {/* Get Started Links */}
          <div className="col-span-1">
            <h4 className="text-sm font-semibold mb-4 text-gray-900 dark:text-white">
              Get Started
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/contact" className="text-gray-600 dark:text-gray-400 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-600 dark:text-gray-400 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 dark:text-gray-400 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300">
                  Help
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div className="col-span-1">
            <h4 className="text-sm font-semibold mb-4 text-gray-900 dark:text-white">
              Connect
            </h4>
            <div className="flex space-x-4">
              <a 
                href="https://www.linkedin.com/company/cognitaix" 
                className="text-gray-600 dark:text-gray-400 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a 
                href="https://twitter.com" 
                className="text-gray-600 dark:text-gray-400 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
                aria-label="Twitter"
              >
                <Twitter size={20} />
              </a>
              <a 
                href="https://github.com" 
                className="text-gray-600 dark:text-gray-400 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
                aria-label="GitHub"
              >
                <Github size={20} />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="border-t border-gray-200 dark:border-gray-800">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <p className="text-center text-sm text-gray-600 dark:text-gray-400">
            &copy; {new Date().getFullYear()} CognitAIX Innovations. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;